var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3405 0.799805C14.2521 0.799858 14.1642 0.814102 14.0803 0.841992L5.90214 3.54199C5.54524 3.66068 5.29999 4.00605 5.29999 4.3998V11.2834C4.82186 10.9248 4.19439 10.6998 3.49999 10.6998C2.00936 10.6998 0.799988 11.707 0.799988 12.9498C0.799988 14.1926 2.00936 15.1998 3.49999 15.1998C4.99061 15.1998 6.19999 14.1926 6.19999 12.9498V7.9998L14.3 5.2998V9.4834C13.8219 9.12481 13.1944 8.89981 12.5 8.89981C11.0094 8.89981 9.79999 9.90696 9.79999 11.1498C9.79999 12.3926 11.0094 13.3998 12.5 13.3998C13.9906 13.3998 15.2 12.3926 15.2 11.1498V1.6998C15.2 1.18652 14.7975 0.799805 14.3405 0.799805ZM3.49999 14.2998C2.52433 14.2998 1.69999 13.6811 1.69999 12.9498C1.69999 12.2186 2.52433 11.5998 3.49999 11.5998C4.47564 11.5998 5.29999 12.2186 5.29999 12.9498C5.29999 13.6811 4.47564 14.2998 3.49999 14.2998ZM12.5 12.4998C11.5243 12.4998 10.7 11.8811 10.7 11.1498C10.7 10.4186 11.5243 9.7998 12.5 9.7998C13.4756 9.7998 14.3 10.4186 14.3 11.1498C14.3 11.8811 13.4756 12.4998 12.5 12.4998ZM14.3 4.35143L6.19999 7.05143V4.3998H6.18424V4.39643L14.3 1.71724V4.35143Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicNote);
export default __webpack_public_path__ + "static/media/music-note.e8d5a39dc7664f9bcb9531307ca08a77.svg";
export { ForwardRef as ReactComponent };